module.exports = __webpack_public_path__ + "img/FAPI-800CW.50f031e9.png";